import React from 'react'
import styled from '@emotion/styled'
import { useSelector } from 'react-redux'
import { radius } from '@mobi/component-library/Theme/Common'
import { Tabs, TabButton } from '@mobi/component-library/Navigation/Tabs'
import { PageHeader } from '@mobi/component-library/Navigation/PageHeader'
import { hexColors } from '@mobi/settings/hexColors'
import { MainContainer } from '@core/Components/Containers'
import { StructuredSearchCriteria } from './Criteria/StructuredSearchCriteria'
import { StructuredSearchResults } from './Results/StructuredSearchResults'
import { performStructuredSearch } from './Service/StructuredSearchService'
import { selectSearchCriteria, selectSearchResults } from './Store/selectors'

export const StructuredSearchPage = (): JSX.Element => {
  const testId = { 'data-tid-structured-search-container': '' }

  const [currentTab, setCurrentTab] = React.useState<'Criteria' | 'Results'>('Criteria')

  const searchResults = useSelector(selectSearchResults)
  const currentSearchCriteria = useSelector(selectSearchCriteria)

  const totalResultCount = searchResults.totalResultCount

  React.useEffect(() => {
    performStructuredSearch(currentSearchCriteria)
  }, [currentSearchCriteria])

  return (
    <MainContainer {...testId}>
      <PageHeader title='Smart Form' />

      <Tabs>
        <TabButton
          content='Criteria'
          isSelected={currentTab === 'Criteria'}
          onClick={() => setCurrentTab('Criteria')}
        />

        <TabButton
          content={
            <>
              Results{' '}
              <TabBadgeStyled data-tid-total-result-count={totalResultCount}>
                {totalResultCount}
              </TabBadgeStyled>
            </>
          }
          isSelected={currentTab === 'Results'}
          onClick={() => setCurrentTab('Results')}
        />
      </Tabs>

      {currentTab === 'Criteria' && (
        <StructuredSearchCriteria setResultsTab={() => setCurrentTab('Results')} />
      )}

      {currentTab === 'Results' && <StructuredSearchResults />}
    </MainContainer>
  )
}

// ======
// Styles
// ======

const TabBadgeStyled = styled.div({
  backgroundColor: hexColors.whiteSmoke,
  border: '0.3rem',
  color: '#808080',
  marginLeft: '0.5rem',
  padding: '0.25rem 0.5rem',
  borderRadius: radius.smx1,
})
